import { Box, MenuItem } from '@mui/material';
import {
  CustomTextArea,
  CustomTextField,
  CustomSelect,
  DialogTitle,
  HorizontalForm,
} from '../../../common';

const GeneralDataSection = ({ selectedBranch, onInputChange, isMobile, companies = [] }) => {
  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos generales
      </DialogTitle>

      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomSelect
            name="uuid_company"
            label="Empresa"
            value={selectedBranch.uuid_company || ''}
            onChange={onInputChange}
            required
            fullWidth
            size="medium"
          >
            {companies.map((company) => (
              <MenuItem key={company.uuid} value={company.uuid}>
                {company.name || company.description}
              </MenuItem>
            ))}
          </CustomSelect>

          <CustomTextField
            name="email"
            label="Email"
            value={selectedBranch.email || ''}
            onChange={onInputChange}
            type="email"
            required
            fullWidth
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomTextField
            name="timezone"
            label="Zona Horaria"
            value={selectedBranch.timezone || ''}
            onChange={onInputChange}
            fullWidth
          />
          <CustomTextField
            name="telephone"
            label="Teléfono"
            value={selectedBranch.telephone || ''}
            onChange={onInputChange}
            required
            fullWidth
          />
        </Box>
      </HorizontalForm>
      <Box px={1}>
        <CustomTextArea
          name="description"
          label="Descripción"
          value={selectedBranch.description || ''}
          onChange={onInputChange}
          required
          fullWidth
        />
      </Box>
    </Box>
  );
};

export default GeneralDataSection;
